<template>
  <div class="wx-callback-page">
    <div class="wx-callback-card">
      <div class="wx-callback-title">微信授权登录</div>
      <div class="wx-callback-desc">{{ message }}</div>
      <van-button v-if="failed" round block type="info" class="wx-callback-btn" @click="goLogin">
        返回登录
      </van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import useCache from "@/utils/user";
import { callbackWxAuth } from "@/api/wxAuth";

export default {
  name: "CreditWxCallback",
  data() {
    return {
      message: "正在处理微信授权，请稍候...",
      failed: false,
    };
  },
  created() {
    this.handleCallback();
  },
  methods: {
    handleCallback() {
      const code = this.$route.query.code;
      const state = this.$route.query.state;
      if (!code) {
        this.failed = true;
        this.message = "缺少微信授权参数，请重新进入公众号菜单。";
        return;
      }
      callbackWxAuth({ code, state })
        .then((res) => {
          const data = (res && res.data && res.data.data) || {};
          if (data.needBind) {
            sessionStorage.setItem("wxAuthPending", JSON.stringify(data));
            this.$router.replace({
              path: "/credit/bind-account",
            });
            return;
          }
          const userData = Object.assign({}, data.userInfo || {}, {
            token: data.token || "",
          });
          useCache.cacheUserData(userData);
          sessionStorage.removeItem("wxAuthPending");
          Toast("登录成功");
          this.$router.replace({ path: "/credit/home" });
        })
        .catch((error) => {
          this.failed = true;
          this.message = (error && error.message) || "微信授权登录失败，请稍后重试。";
        });
    },
    goLogin() {
      this.$router.replace({
        path: "/credit/login",
        query: { source: "credit" },
      });
    },
  },
};
</script>

<style scoped>
.wx-callback-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f0f4ff;
}

.wx-callback-card {
  width: 100%;
  max-width: 360px;
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px;
  box-shadow: 0 8px 24px rgba(21, 102, 193, 0.12);
  text-align: center;
}

.wx-callback-title {
  font-size: 20px;
  font-weight: 700;
  color: #0d1b3e;
}

.wx-callback-desc {
  margin-top: 16px;
  font-size: 14px;
  line-height: 22px;
  color: #5b6b8a;
}

.wx-callback-btn {
  margin-top: 24px;
  background: #1566c1;
  border-color: #1566c1;
}
</style>
